(function () {
  if (window.WoodarqFaqSection && window.WoodarqFaqSection.initAll) {
    window.WoodarqFaqSection.initAll();
    return;
  }

  var ROOT_SELECTOR = '[data-woodarq-faq]';
  var ITEM_SELECTOR = '[data-faq-item]';
  var TOGGLE_SELECTOR = '[data-faq-toggle]';
  var ANSWER_SELECTOR = '[data-faq-answer]';
  var SPLIT_SELECTOR = '[data-faq-text-reveal]';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function getReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function splitChars(el) {
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;

    el.textContent = '';

    for (var i = 0; i < text.length; i += 1) {
      var span = document.createElement('span');
      span.className = 'wa-faq-char';
      span.style.setProperty('--wa-faq-split-index', i);
      span.textContent = text[i] === ' ' ? '\u00A0' : text[i];
      el.appendChild(span);
    }
  }

  function splitWords(el) {
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;

    var words = text.split(' ');
    el.textContent = '';

    words.forEach(function (word, index) {
      var span = document.createElement('span');
      span.className = 'wa-faq-word';
      span.style.setProperty('--wa-faq-split-index', index);
      span.textContent = word;
      el.appendChild(span);

      if (index < words.length - 1) {
        el.appendChild(document.createTextNode(' '));
      }
    });
  }

  function prepareText(root) {
    toArray(root.querySelectorAll(SPLIT_SELECTOR)).forEach(function (el) {
      if (el.__waFaqSplitReady) return;
      el.__waFaqSplitReady = true;

      var splitType = el.getAttribute('data-faq-split');
      if (!splitType || getReducedMotion()) return;

      if (splitType === 'chars') splitChars(el);
      if (splitType === 'words') splitWords(el);
    });
  }

  function updateSmoothScroll() {
    window.dispatchEvent(new Event('resize'));

    if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
      window.ScrollTrigger.refresh();
    }
  }

  function setAnswerHeight(answer, height) {
    answer.style.height = typeof height === 'number' ? height + 'px' : height;
  }

  function getAnswerHeight(answer) {
    if (!answer) return 0;

    var inner = answer.querySelector('[data-faq-answer-copy]');
    return Math.max(
      answer.scrollHeight || 0,
      inner ? inner.scrollHeight || 0 : 0
    );
  }

  function openItem(item, instant) {
    var button = item.querySelector(TOGGLE_SELECTOR);
    var answer = item.querySelector(ANSWER_SELECTOR);
    if (!button || !answer || item.classList.contains('is-open')) return;

    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');

    if (instant || getReducedMotion()) {
      setAnswerHeight(answer, 'auto');
      updateSmoothScroll();
      return;
    }

    setAnswerHeight(answer, 0);
    answer.offsetHeight;

    requestAnimationFrame(function () {
      setAnswerHeight(answer, getAnswerHeight(answer));
      updateSmoothScroll();
    });

    var onEnd = function (event) {
      if (event.target !== answer) return;
      answer.removeEventListener('transitionend', onEnd);
      if (item.classList.contains('is-open')) setAnswerHeight(answer, 'auto');
      updateSmoothScroll();
    };

    answer.addEventListener('transitionend', onEnd);
  }

  function closeItem(item, instant) {
    var button = item.querySelector(TOGGLE_SELECTOR);
    var answer = item.querySelector(ANSWER_SELECTOR);
    if (!button || !answer || !item.classList.contains('is-open')) return;

    item.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');

    if (instant || getReducedMotion()) {
      setAnswerHeight(answer, 0);
      updateSmoothScroll();
      return;
    }

    setAnswerHeight(answer, getAnswerHeight(answer));
    answer.offsetHeight;
    requestAnimationFrame(function () {
      setAnswerHeight(answer, 0);
    });

    var onEnd = function (event) {
      if (event.target !== answer) return;
      answer.removeEventListener('transitionend', onEnd);
      updateSmoothScroll();
    };

    answer.addEventListener('transitionend', onEnd);
  }

  function closeSiblings(root, currentItem) {
    if (root.getAttribute('data-close-others') !== 'true') return;

    toArray(root.querySelectorAll(ITEM_SELECTOR)).forEach(function (item) {
      if (item !== currentItem) closeItem(item);
    });
  }

  function setupAccordion(root) {
    var items = toArray(root.querySelectorAll(ITEM_SELECTOR));

    items.forEach(function (item, index) {
      var button = item.querySelector(TOGGLE_SELECTOR);
      var answer = item.querySelector(ANSWER_SELECTOR);
      if (!button || !answer) return;

      item.style.setProperty('--wa-faq-item-delay', Math.min(index * 75, 300) + 'ms');

      if (item.classList.contains('is-open') && button.getAttribute('aria-expanded') === 'true') {
        answer.setAttribute('aria-hidden', 'false');
        setAnswerHeight(answer, 'auto');
      } else {
        item.classList.remove('is-open');
        setAnswerHeight(answer, 0);
        answer.setAttribute('aria-hidden', 'true');
        button.setAttribute('aria-expanded', 'false');
      }

      if (!button.__waFaqClickBound) {
        button.__waFaqClickBound = true;
        button.addEventListener('click', function () {
          if (item.classList.contains('is-open')) {
            closeItem(item);
            return;
          }

          closeSiblings(root, item);
          openItem(item);
        });
      }
    });

    if (root.getAttribute('data-open-first') === 'true' && items.length && !root.__waFaqOpenedFirst) {
      root.__waFaqOpenedFirst = true;
      openItem(items[0], true);
    }
  }

  function setupVisibility(root) {
    if (root.__waFaqRootObserverBound) return;
    root.__waFaqRootObserverBound = true;

    var items = toArray(root.querySelectorAll(ITEM_SELECTOR));

    if (!('IntersectionObserver' in window) || getReducedMotion()) {
      root.classList.add('is-faq-visible');
      items.forEach(function (item) { item.classList.add('is-faq-visible'); });
      return;
    }

    var rootObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        root.classList.add('is-faq-visible');
        rootObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -12% 0px' });

    rootObserver.observe(root);

    var itemObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-faq-visible');
        itemObserver.unobserve(entry.target);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (item) {
      itemObserver.observe(item);
    });
  }

  function initRoot(root) {
    if (!root) return;

    prepareText(root);
    setupAccordion(root);
    setupVisibility(root);
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    toArray(container.querySelectorAll(ROOT_SELECTOR)).forEach(initRoot);
  }

  window.WoodarqFaqSection = {
    initAll: initAll,
    initRoot: initRoot,
    openItem: openItem,
    closeItem: closeItem
  };

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  window.addEventListener('load', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target && event.target.closest ? event.target.closest(ITEM_SELECTOR) : null;
    if (block) openItem(block, true);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var block = event.target && event.target.closest ? event.target.closest(ITEM_SELECTOR) : null;
    if (block) closeItem(block, true);
  });

  initAll();
})();
